// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const nonIE11MaxTokenLength = 2 ** 16;

export const getMaxTokenLength = (): number => nonIE11MaxTokenLength;
